import { wsName } from "..";
import axios, { AxiosResponse } from "axios";
import WsAccessor from "../WebSockets/WsAccessor";
import _ from "lodash";

type CustomErrorProcessor = (error: any) => boolean;

export default class RequestsProcessor {
  accessor = new WsAccessor();
  api = axios.create({
    baseURL: `${_.trimEnd(this.accessor.configuration().userManagementUrl, '/')}/api/`,
    withCredentials: true
  });

  async get<T>(
    query: string,
    comment: string = "",
    customErrorProcessor?: CustomErrorProcessor
  ): Promise<T> {
    return await this.request<T>(async () => {
      let result = await this.api.get<T>(query);
      if (result.status === 200 || 204) {
        console.log(`${wsName}: ${comment}:`, result.data);
      } else {
        result = null;
      }
      return result;
    }, customErrorProcessor);
  }

  async post<T>(
    query: string,
    comment: string = "",
    params: any = {},
    customErrorProcessor?: CustomErrorProcessor
  ): Promise<T> {
    return await this.request<T>(async () => {
      let result = await this.api.post(query, params);
      console.log(`${comment}:`, result.data);
      return result;
    }, customErrorProcessor);
  }

  private async request<T>(
    query: () => Promise<AxiosResponse<T>>,
    customErrorProcessor?: CustomErrorProcessor
  ): Promise<T> {
    let result: AxiosResponse<T> | null = null;
    try {
      result = await query();
    } catch (error) {
      let handled = _.isFunction(customErrorProcessor) && customErrorProcessor(error);
      if (!handled && error.response && error.response.status === 401) {
        window.location.reload();
      }
      result = null;
    }

    if (result && result.data) {
      return result.data;
    } else {
      return null;
    }
  }
}
